import { TFunction } from 'i18next';

type FlatDataItem = {
  portfolioId: string;
};

export const portfolioOptionsGrouped = (flatData: FlatDataItem[], t: TFunction) => {
  const portfolioCountMap = new Map<string, number>();

  flatData.forEach((item) => {
    const portfolioId = item.portfolioId.toString();
    portfolioCountMap.set(portfolioId, (portfolioCountMap.get(portfolioId) || 0) + 1);
  });

  return Array.from(portfolioCountMap.entries())
    .map(([id, count]) => ({
      label: id,
      value: id,
      count,
      chipLabel: id
    }))
    .sort((a, b) => a.label.localeCompare(b.label, undefined, { numeric: true }));
};
